import { Size } from '@/types';
import { getRotatedRect } from '@/utils/math/getRotatedRect';

export function rotatedSize(rotationInDeg: number, size: Size): Size {
  const rotatedRect = getRotatedRect(rotationInDeg, {
    x: 0,
    y: 0,
    width: size.width,
    height: size.height,
  });

  return {
    width: rotatedRect.width,
    height: rotatedRect.height,
    unit: 'mm',
  };
}
